import './Header.less';

export const prefix = 'oc-c-header';

export { default } from './Header';